var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", [
    _c(
      "a",
      {
        staticClass: "item_list",
        attrs: { href: _vm.articleUrl, target: "_blank" },
      },
      [
        _c("div", { staticClass: "thumb_g" }, [
          _c("img", {
            attrs: { src: _vm.imageUrl, width: "54", height: "54", alt: "" },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "desc_list" }, [
          _c("strong", { staticClass: "tit_list" }, [
            _vm._v(_vm._s(_vm.keyword)),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "txt_list" }, [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _c("p", { staticClass: "date_list" }, [_vm._v(_vm._s(_vm.regDate))]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }